// @ts-nocheck
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";
import { BillToModel, OrderModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";

export interface InlineAddressPresentationProps extends ExpandStyles<InlineAddressStyles> {}

export type InlineAddressProps = InlineAddressPresentationProps &
    (
        | { billTo: OrderModel | undefined; shipTo?: never; address?: never }
        | { shipTo: OrderModel | undefined; billTo?: never; address?: never }
        | { address: BillToModel | ShipToModel | undefined; billTo?: never; shipTo?: never }
    );

export interface InlineAddressStyles {
    addressText?: TypographyPresentationProps;
}

export const inlineAddressStyles: InlineAddressStyles = {};

const InlineAddress: FC<InlineAddressProps> = ({ extendedStyles, overridedStyles, ...addressProps }) => {
    const styles = useExpandProps(inlineAddressStyles, extendedStyles, overridedStyles);

    let parts: (string | undefined)[];

    if ("billTo" in addressProps) {
        const model = addressProps.billTo;

        if (!model) {
            return null;
        }

        parts = [
            model.btCompanyName,
            model.btAddress1,
            model.btAddress2,
            model.billToCity ? `${model.billToCity},` : undefined,
            model.billToState,
            model.billToPostalCode ? `${model.billToPostalCode},` : undefined,
            model.btCountry,
        ];
    } else if ("shipTo" in addressProps) {
        const model = addressProps.shipTo;

        if (!model) {
            return null;
        }

        parts = [
            model.stCompanyName,
            model.stAddress1,
            model.stAddress2,
            model.shipToCity ? `${model.shipToCity},` : undefined,
            model.shipToState,
            model.shipToPostalCode ? `${model.shipToPostalCode},` : undefined,
            model.stCountry,
        ];
    } else {
        const model = addressProps.address;

        if (!model) {
            return null;
        }

        parts = [
            model.companyName,
            model.address1,
            model.address2,
            model.city ? `${model.city},` : undefined,
            model.state?.abbreviation,
            model.postalCode ? `${model.postalCode},` : undefined,
            model.country?.name,
        ];
    }

    const address = parts.filter(Boolean).join(" ");

    return <Typography {...styles.addressText}>{address}</Typography>;
};

export default InlineAddress;
